// Product accordion functionality
$('.product-accordion-button').on('click', function() {
    $(this).find('svg').toggleClass('rotate-180');
    $(this).parent().find('.product-accordion-content').slideToggle(300);
});

// Variant selection and Add to Cart functionality
$(document).ready(function() {
    const $addToCartBtn = $('#addToCartBtn');
    const $variantInputs = $('input[name="id"]');
    
    // Function to update Add to Cart button state
    function updateAddToCartButton() {
        const hasMultipleVariants = $variantInputs.length > 1;
        const selectedVariant = $('input[name="id"]:checked');
        const isVariantSelected = selectedVariant.length > 0;
        const isSelectedVariantAvailable = isVariantSelected && !selectedVariant.prop('disabled');
        
        if (!hasMultipleVariants) {
            // Single variant product - check if it's available using data-available attribute
            const singleVariant = $variantInputs.first();
            const isAvailable = singleVariant.data('available') === true || singleVariant.data('available') === 'true';
            
            if (!isAvailable) {
                $addToCartBtn.prop('disabled', true).text('SOLD OUT');
                $addToCartBtn.removeClass('bg-[#FF6C2A] hover:bg-[#FF6C2A]/90').addClass('disabled:bg-gray-400');
            } else {
                $addToCartBtn.prop('disabled', false).text('DODAJ DO KOSZYKA');
                $addToCartBtn.removeClass('disabled:bg-gray-400').addClass('bg-[#FF6C2A] hover:bg-[#FF6C2A]/90');
            }
        } else {
            // Multiple variants - keep orange color but manage click functionality
            if (isVariantSelected && isSelectedVariantAvailable) {
                $addToCartBtn.prop('disabled', false).text('DODAJ DO KOSZYKA');
                $addToCartBtn.removeClass('pointer-events-none').addClass('cursor-pointer');
            } else if (isVariantSelected && !isSelectedVariantAvailable) {
                $addToCartBtn.prop('disabled', true).text('SOLD OUT');
                $addToCartBtn.removeClass('bg-[#FF6C2A] hover:bg-[#FF6C2A]/90 cursor-pointer').addClass('disabled:bg-gray-400');
            } else {
                // No variant selected - keep orange but prevent interaction
                $addToCartBtn.prop('disabled', false).text('WYBIERZ ROZMIAR');
                $addToCartBtn.removeClass('disabled:bg-gray-400').addClass('bg-[#FF6C2A] pointer-events-none cursor-default');
            }
        }
    }
    
    // Handle variant selection change
    $variantInputs.on('change', function() {
        updateAddToCartButton();
    });
    
    // Prevent form submission if no variant is selected or variant is unavailable
    $('form[action*="product"]').on('submit', function(e) {
        const hasMultipleVariants = $variantInputs.length > 1;
        const selectedVariant = $('input[name="id"]:checked');
        const isVariantSelected = selectedVariant.length > 0;
        const isSelectedVariantAvailable = isVariantSelected && !selectedVariant.prop('disabled');
        
        if (hasMultipleVariants && (!isVariantSelected || !isSelectedVariantAvailable)) {
            e.preventDefault();
            updateAddToCartButton(); // Update button state to show appropriate message
            return false;
        }
    });
    
    // Initialize button state on page load
    updateAddToCartButton();
});

// Image gallery functionality
$(document).ready(function() {
    let currentMediaIndex = 0;
    let popupMediaIndex = 0;
    const totalMedia = $('.main-product-media').length;
    
    // Function to switch to a specific media item
    function switchToMedia(mediaIndex) {
        // Remove active class from all thumbnails
        $('.thumbnail-container').removeClass('active');
        $('.thumbnail-container img').removeClass('border-[#FF6C2A]').addClass('border-transparent');
        
        // Add active class to selected thumbnail
        $(`.thumbnail-container[data-media-index="${mediaIndex}"]`).addClass('active');
        $(`.thumbnail-container[data-media-index="${mediaIndex}"] img`).removeClass('border-transparent').addClass('border-[#FF6C2A]');
        
        // Hide all main media
        $('.main-product-media').addClass('hidden');
        
        // Show the selected main media
        const selectedMedia = $(`.main-product-media[data-media-index="${mediaIndex}"]`);
        selectedMedia.removeClass('hidden');
        
        // Pause all videos first
        $('video').each(function() {
            this.pause();
        });
        
        // Auto-play video if the selected media is a video
        const mediaType = selectedMedia.data('media-type');
        if (mediaType === 'video') {
            const videoElement = selectedMedia.find('video')[0];
            if (videoElement) {
                // Small delay to ensure the video is visible before playing
                setTimeout(() => {
                    videoElement.muted = false; // Unmute the video
                    videoElement.play().catch(function(error) {
                        console.log('Video autoplay failed:', error);
                        // If unmuted autoplay fails, try muted autoplay
                        videoElement.muted = true;
                        videoElement.play().catch(function(mutedError) {
                            console.log('Muted video autoplay also failed:', mutedError);
                        });
                    });
                }, 100);
            }
        }
        
        currentMediaIndex = mediaIndex;
    }

    // Function to update popup media
    function updatePopupMedia(mediaIndex) {
        const selectedMedia = $(`.main-product-media[data-media-index="${mediaIndex}"]`);
        const mediaType = selectedMedia.data('media-type');
        
        // Hide both containers first
        $('#popupImage').addClass('hidden');
        $('#popupVideo').addClass('hidden').empty();
        
        if (mediaType === 'video') {
            // Handle video
            const videoElement = selectedMedia.find('video')[0];
            if (videoElement) {
                const videoClone = videoElement.cloneNode(true);
                videoClone.className = 'max-w-full max-h-full object-contain rounded-lg shadow-2xl';
                videoClone.controls = true;
                videoClone.autoplay = true;
                videoClone.loop = true;
                videoClone.muted = false; // Unmute popup video
                
                $('#popupVideo').append(videoClone).removeClass('hidden');
            }
        } else {
            // Handle image
            const largeSrc = selectedMedia.data('large-src') || selectedMedia.attr('src');
            const alt = selectedMedia.attr('alt');
            
            $('#popupImage').attr('src', largeSrc).attr('alt', alt).removeClass('hidden');
        }
        
        $('#imageCounter').text(`${mediaIndex + 1} / ${totalMedia}`);
        popupMediaIndex = mediaIndex;
    }

    // Function to open popup
    function openMediaPopup(mediaIndex) {
        updatePopupMedia(mediaIndex);
        $('#imagePopup').removeClass('hidden').addClass('flex');
        $('body').addClass('overflow-hidden'); // Prevent background scrolling
    }

    // Function to close popup
    function closeMediaPopup() {
        $('#imagePopup').removeClass('flex').addClass('hidden');
        $('body').removeClass('overflow-hidden'); // Restore background scrolling
        
        // Pause any playing video in popup
        $('#popupVideo video').each(function() {
            this.pause();
        });
    }

    // Handle main media clicks to open popup
    $('.main-product-media').on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        const mediaIndex = $(this).data('media-index');
        openMediaPopup(mediaIndex);
    });

    // Handle close popup button
    $(document).on('click', '#closePopup', function(e) {
        e.preventDefault();
        e.stopPropagation();
        closeMediaPopup();
    });

    // Handle clicking outside the media to close popup
    $(document).on('click', '#imagePopup', function(e) {
        if (e.target === this) {
            closeMediaPopup();
        }
    });

    // Handle escape key to close popup
    $(document).on('keydown', function(e) {
        if (e.key === 'Escape' && $('#imagePopup').hasClass('flex')) {
            closeMediaPopup();
        }
    });

    // Handle previous media button in popup
    $(document).on('click', '#prevImage', function(e) {
        e.preventDefault();
        e.stopPropagation();
        const prevIndex = popupMediaIndex > 0 ? popupMediaIndex - 1 : totalMedia - 1;
        updatePopupMedia(prevIndex);
    });

    // Handle next media button in popup
    $(document).on('click', '#nextImage', function(e) {
        e.preventDefault();
        e.stopPropagation();
        const nextIndex = popupMediaIndex < totalMedia - 1 ? popupMediaIndex + 1 : 0;
        updatePopupMedia(nextIndex);
    });

    // Handle keyboard navigation in popup
    $(document).on('keydown', function(e) {
        if ($('#imagePopup').hasClass('flex')) {
            if (e.key === 'ArrowLeft') {
                const prevIndex = popupMediaIndex > 0 ? popupMediaIndex - 1 : totalMedia - 1;
                updatePopupMedia(prevIndex);
            } else if (e.key === 'ArrowRight') {
                const nextIndex = popupMediaIndex < totalMedia - 1 ? popupMediaIndex + 1 : 0;
                updatePopupMedia(nextIndex);
            }
        }
    });
    
    // Handle thumbnail clicks
    $('.thumbnail-container').on('click', function() {
        const mediaIndex = $(this).data('media-index');
        switchToMedia(mediaIndex);
    });
    
    // Set initial active state for first thumbnail
    $('.thumbnail-container.active img').removeClass('border-transparent').addClass('border-[#FF6C2A]');
    
    // Touch/swipe functionality for mobile (main gallery)
    let startX = 0;
    let startY = 0;
    let endX = 0;
    let endY = 0;
    const minSwipeDistance = 50; // Minimum distance for a swipe
    
    $('.image-slider-container').on('touchstart', function(e) {
        startX = e.originalEvent.touches[0].clientX;
        startY = e.originalEvent.touches[0].clientY;
    });
    
    $('.image-slider-container').on('touchmove', function(e) {
        // Prevent default scrolling behavior during horizontal swipes
        const moveX = e.originalEvent.touches[0].clientX;
        const moveY = e.originalEvent.touches[0].clientY;
        const deltaX = Math.abs(moveX - startX);
        const deltaY = Math.abs(moveY - startY);
        
        // If horizontal movement is greater than vertical, prevent default scrolling
        if (deltaX > deltaY) {
            e.preventDefault();
        }
    });
    
    $('.image-slider-container').on('touchend', function(e) {
        endX = e.originalEvent.changedTouches[0].clientX;
        endY = e.originalEvent.changedTouches[0].clientY;
        
        const deltaX = endX - startX;
        const deltaY = endY - startY;
        
        // Check if it's a horizontal swipe (more horizontal than vertical movement)
        if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > minSwipeDistance) {
            if (deltaX > 0) {
                // Swipe right - go to previous media
                const prevIndex = currentMediaIndex > 0 ? currentMediaIndex - 1 : totalMedia - 1;
                switchToMedia(prevIndex);
            } else {
                // Swipe left - go to next media
                const nextIndex = currentMediaIndex < totalMedia - 1 ? currentMediaIndex + 1 : 0;
                switchToMedia(nextIndex);
            }
        }
    });

    // Touch/swipe functionality for popup
    let popupStartX = 0;
    let popupStartY = 0;

    $('#popupImage, #popupVideo').on('touchstart', function(e) {
        popupStartX = e.originalEvent.touches[0].clientX;
        popupStartY = e.originalEvent.touches[0].clientY;
    });

    $('#popupImage, #popupVideo').on('touchend', function(e) {
        const popupEndX = e.originalEvent.changedTouches[0].clientX;
        const popupEndY = e.originalEvent.changedTouches[0].clientY;
        
        const deltaX = popupEndX - popupStartX;
        const deltaY = popupEndY - popupStartY;
        
        // Check if it's a horizontal swipe
        if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > minSwipeDistance) {
            if (deltaX > 0) {
                // Swipe right - go to previous media
                const prevIndex = popupMediaIndex > 0 ? popupMediaIndex - 1 : totalMedia - 1;
                updatePopupMedia(prevIndex);
            } else {
                // Swipe left - go to next media
                const nextIndex = popupMediaIndex < totalMedia - 1 ? popupMediaIndex + 1 : 0;
                updatePopupMedia(nextIndex);
            }
        }
    });
    
    // Initialize gallery - auto-play first video if it's a video
    if (totalMedia > 0) {
        const firstMedia = $(`.main-product-media[data-media-index="0"]`);
        const firstMediaType = firstMedia.data('media-type');
        
        if (firstMediaType === 'video') {
            const firstVideoElement = firstMedia.find('video')[0];
            if (firstVideoElement) {
                // Auto-play the first video with a small delay
                setTimeout(() => {
                    firstVideoElement.muted = false; // Unmute the video
                    firstVideoElement.play().catch(function(error) {
                        console.log('First video autoplay failed:', error);
                        // If unmuted autoplay fails, try muted autoplay
                        firstVideoElement.muted = true;
                        firstVideoElement.play().catch(function(mutedError) {
                            console.log('Muted video autoplay also failed:', mutedError);
                        });
                    });
                }, 500);
            }
        }
    }
});